var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLibraryOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-library-orange",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.87,
    height: 20.87,
    viewBox: "0 0 20.87 20.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Bounds",
    d: "M0,0H20.87V20.87H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M7.826,17.869h0A11.444,11.444,0,0,0,0,14.783V5.218A11.443,11.443,0,0,1,7.826,8.3a11.444,11.444,0,0,1,7.826-3.087v9.565h0a11.474,11.474,0,0,0-7.821,3.085Zm0-12.652a2.609,2.609,0,1,1,2.608-2.609A2.612,2.612,0,0,1,7.826,5.218Z",
    transform: "translate(2.609 1.739)",
    fill: "#f39628"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLibraryOrange);
export default __webpack_public_path__ + "static/media/icon-library-orange.0054832823b22ffd9bb1aedfb215d3e7.svg";
export { ForwardRef as ReactComponent };